export default __webpack_public_path__ + "static/media/metacritic.ccfca856.svg";